import React, { ReactElement } from 'react';

interface StepProps {
  children: ReactElement;
  goBackward?: () => boolean | void;
  goForward?: () => boolean | void;
  [key: string]: unknown;
}

export class Step extends React.Component<StepProps> {
  goBackward = () => {
    if (this.props.goBackward) {
      return this.props.goBackward();
    }
    return true;
  };

  goForward = () => {
    if (this.props.goForward) {
      return this.props.goForward();
    }
    return true;
  };

  render() {
    const content = React.cloneElement(this.props.children, this.props);
    return <div>{content}</div>;
  }
}
